<template>
  <div
    v-if="data"
    class="discover-section-cards"
  >
    <div class="card">
      <p class="card-title">
        {{ $t("inventory.unique") }}
      </p>
      <p class="card-subtitle">
        <svg
          height="20"
          width="20"
        >
          <use xlink:href="/icons/sprite.svg#i-user" />
        </svg>
        <span>{{ Number(data.unique_inventories).toLocaleString() }}</span>
      </p>
    </div>
    <div class="card">
      <p class="card-title">
        {{ $t("inventory.total_value") }}
      </p>
      <p class="card-subtitle">
        <svg
          height="20"
          width="20"
        >
          <use xlink:href="/icons/sprite.svg#i-dollar" />
        </svg>
        <UiPrice
          :decimal="0"
          :price="data.total_value"
        />
      </p>
    </div>
    <div class="card">
      <p class="card-title">
        {{ $t("inventory.average_value") }}
      </p>
      <p class="card-subtitle">
        <svg
          height="20"
          width="20"
        >
          <use xlink:href="/icons/sprite.svg#i-chart" />
        </svg>
        <UiPrice
          :decimal="0"
          :price="data.avg_value"
        />
      </p>
    </div>
    <div class="card">
      <p class="card-title">
        {{ $t("inventory.average_item_count") }}
      </p>
      <p class="card-subtitle">
        <svg
          height="20"
          width="20"
        >
          <use xlink:href="/icons/sprite.svg#i-search-list" />
        </svg>
        <span>{{ Number(data.avg_items_count).toLocaleString() }}</span>
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { InventoriesCommonInfo } from '~/graphql/generated/schema-types';

defineProps<{
  data?: InventoriesCommonInfo
}>();
</script>

<style lang="scss" scoped>
.discover-section {
  .discover-section-cards {
    margin-top: 24px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;

    @media screen and (max-width: 989px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media screen and (max-width: 480px) {
      grid-template-columns: repeat(1, 1fr);
      gap: 8px;
    }

    .card {
      padding: 12px;
      border-radius: 12px;
      background: var(--surfaces-high-container);
      border: 1px solid var(--surfaces-outline);
      display: flex;
      flex-direction: column;
      justify-content: center;

      .card-title {
        font-size: 16px;
        margin-bottom: 8px;
      }

      .card-subtitle {
        display: flex;
        align-items: center;
        gap: 8px;
        font-weight: 600;
        color: var(--surfaces-on-surface);

        svg {
          color: var(--accent-primary);
        }
      }
    }
  }
}
</style>
